import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { Packaging } from 'shared/packages/domain/packaging';
import type { PackagingLevel } from 'shared/packages/domain/packagingLevel';
import { usePackagingStore } from 'shared/packages/stores/packagingStore';

export interface CreatePackaging {
  name: string;
  description: string;
  level: PackagingLevel;
}

export interface CreatePackagingResponse {
  ok: true;
  packaging: Packaging;
}

export function useCreatePackaging() {
  const store = usePackagingStore();

  return useCreateEntityApi<CreatePackaging, CreatePackagingResponse>({
    url: 'packaging',
    translate: (t) => t.packaging.actions.create,
    async processOk(response) {
      const json = await response.json() as Packaging;
      store.add(json);
      return {
        ok: true,
        packaging: json,
      };
    },
  });
}
